module.exports = __webpack_public_path__ + "img/storage-update.3ff7b76c.svg";